import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiSlice } from './apiSlice';
import { DEPLOYENVIRONMENT } from 'apiConfig';

export const socketSlice = createApi({
	reducerPath: 'socket',
	baseQuery: fetchBaseQuery({
		baseUrl: `https://${DEPLOYENVIRONMENT}garlicerp.com:9443`,
		prepareHeaders: async (headers) => {
			headers.set('content-type', 'application/json');
			return headers;
		},
	}),
	endpoints: (builder) => ({
		GetConversationByRoom: builder.mutation({
			query: (data) => ({
				url: '/get-pc-messages',
				method: 'POST',
				body: data,
			}),
			transformResponse: (response) => {
				return {
					...response,
					chats: response?.chats ? response?.chats?.reverse() : [],
				};
			},
		}),
		MarkAsReadConversation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/mark-seen-pc-messages',
				method: 'POST',
				body: data,
			}),
		}),
		GetTaskConversation: builder.mutation({
			query: (data) => ({
				url: '/get-cc-messages',
				method: 'POST',
				body: data,
			}),
			transformResponse: (response) => {
				return {
					...response,
					chats: response?.chats ? response?.chats?.reverse() : [],
				};
			},
		}),
	}),
});

export const socketSliceTwo = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		GetConversationByRoom: builder.mutation({
			query: (data) => ({
				url: `/lynorg-service/endpoint/personal-chat/get-all?page=${data?.page}&&target=${data?.roomId}`,
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
			// transformResponse: (response, meta, arg) => {
			//   return {
			//     ...response,
			//     chats: response?.chats ? response?.chats?.reverse() : [],
			//   };
			// },
		}),
		GetTaskConversation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade-chat/get-all',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
			// transformResponse: (response, meta, arg) => {
			//   return {
			//     ...response,
			//     chats: response?.chats ? response?.chats?.reverse() : [],
			//   };
			// },
		}),
		GetCascadeConversation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade-chat-v3/get-all',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
			// transformResponse: (response, meta, arg) => {
			//   return {
			//     ...response,
			//     chats: response?.chats ? response?.chats?.reverse() : [],
			//   };
			// },
		}),
	}),
});

export const { useMarkAsReadConversationMutation } = socketSlice;
export const { useGetConversationByRoomMutation, useGetTaskConversationMutation, useGetCascadeConversationMutation } = socketSliceTwo;
